import moment from 'moment'

export const timeRangeValue = (format: string, addStart: any=null, addEnd: any=null, startOf: any='', endOf: any='', month: any=null) => {

    if (month) {
        return {from: moment().month(month.start).startOf(startOf).format(format), to: moment().month(month.end).endOf(endOf).format(format)}
    }
    else {
        return {
            from: addStart ? moment().startOf(startOf).add(addStart.range, addStart.type).format(format) : moment().startOf(startOf).format(format),
            to: addEnd ? moment().endOf(endOf).add(addEnd.range, addEnd.type).format(format) : moment().endOf(endOf).format(format)
        }
    }
}
